<template>
    <header class="creator-topbar">
        <router-link class="creator-brand" to="/main" aria-label="返回吉享空间首页">
            <img src="@/assets/creator-center/brand.png" alt="吉享空间" />
        </router-link>

        <div class="creator-title-lockup" aria-label="创作者中心">
            <div>
                <p class="creator-title">创作者中心</p>
                <span class="creator-title-note">MAKE · SHARE · GLOW</span>
            </div>
        </div>

        <div class="creator-topbar-user">
            <div class="creator-topbar-user-copy">
                <span class="creator-topbar-user-name">{{ user.nickname }}</span>
                <span class="creator-topbar-user-sub">{{ user.certificationText }}</span>
            </div>
            <div class="creator-avatar-frame" :aria-label="`${user.nickname}的头像`">
                <img v-if="user.avatarUrl" :src="user.avatarUrl" :alt="`${user.nickname}的头像`" />
                <span v-else aria-hidden="true">{{ user.avatarText }}</span>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "CreatorCenterHeader",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.creator-topbar {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    min-height: 98px;
    background: #fff;
    border-bottom: 1px solid #f0e4e5;
}

.creator-brand {
    display: inline-flex;
    align-items: center;
    justify-self: start;
    width: 226px;
    height: 66px;
    overflow: hidden;
    text-decoration: none;
}

.creator-brand img {
    display: block;
    width: 226px;
    height: 66px;
    object-fit: contain;
}

.creator-title-lockup {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 324px;
    padding: 7px 22px 9px;
    background: rgba(255, 255, 255, .52);
    border: 1px solid rgba(255, 255, 255, .84);
    border-radius: 999px;
    box-shadow: 0 5px 14px rgba(103, 66, 119, .07);
}

.creator-title {
    margin: 0;
    color: #5c4778;
    font-size: 27px;
    font-weight: 800;
    letter-spacing: .08em;
    line-height: 1.08;
    text-align: center;
    text-indent: .08em;
    white-space: nowrap;
}

.creator-title-note {
    display: block;
    margin-top: 3px;
    color: #ba86aa;
    font-family: Inter, sans-serif;
    font-size: 8px;
    font-weight: 800;
    letter-spacing: .2em;
    line-height: 1;
    text-align: center;
    text-indent: .2em;
}

.creator-topbar-user {
    justify-self: end;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    min-width: 226px;
    margin-right: 32px;
}

.creator-topbar-user-copy {
    display: grid;
    text-align: right;
    line-height: 1.28;
}

.creator-topbar-user-name {
    color: #332d49;
    font-size: 14px;
    font-weight: 700;
}

.creator-topbar-user-sub {
    color: #8b7891;
    font-size: 12px;
}

.creator-avatar-frame {
    display: grid;
    width: 60px;
    height: 60px;
    place-items: center;
    overflow: hidden;
    color: #563671;
    background: #ffd9e4;
    border: 1px solid #f0c8d7;
    border-radius: 50%;
    flex: 0 0 auto;
    font-family: Georgia, "Songti SC", serif;
    font-size: 20px;
    font-weight: 700;
}

.creator-avatar-frame img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
